import $ from 'jquery';
import TicketSelector from './TicketSelector';
import AdditionalEventsSelector from './AdditionalEventsSelector';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import { loadModal } from '../../AsyncLoader';

const { FieldValidationProvider } = window.tnew.lib;

class EventDetail {
  constructor({ formSelector, ticketSelectorOptions, isSeatMapModalVisible }) {
    this.ticketSelector = new TicketSelector(formSelector, ticketSelectorOptions);
    this.additionalEventsSelector = new AdditionalEventsSelector();

    const formId = formSelector.replace('#', '');

    FieldValidationProvider.createStandardProvider(formId);

    const $labels = $('.tn-detail-production-text-show-link, .tn-detail-production-text-hide-link');
    $('.tn-detail-production-text-toggle-link').on('click', () => {
      $labels.toggleClass('hide');
    });

    if (isSeatMapModalVisible) {
      this.initSeatMapModal();
    }
  }

  async initSeatMapModal() {
    const $btn = $('.tn-event-detail__btn-view-seat-map-modal');
    const $dialogBody = $('#tn-event-detail-seat-map-modal-body');

    $dialogBody.remove().show();

    const Modal = await loadModal();
    
    const { title, labelBtnAccept } = this.getSeatMapModalProperties();

    $btn.on('click', () => {
      Modal.alert({
        className: 'tn-ticketing-module-map-modal',
        title,
        labelBtnAccept,
        bodyContents: $dialogBody,
        returnFocusTo: $btn[0],
      });
    });
  }
  
  getSeatMapModalProperties() {
    const key = ComponentKeys.STATIC_BEST_AVAILABLE;

    return {
      title: ContentStorage.get(key, 'Heading'),
      labelBtnAccept: ContentStorage.get(key, 'SeatMapModalCloseButtonText'),
    };
  }
}

window.tnew.EventDetail = EventDetail;

export default EventDetail;



// WEBPACK FOOTER //
// ./V7/events/detail/EventDetail.js